export function validateConditions(conditions) {
  const validOperators = ['==', '!=', '>', '<', '>=', '<='];

  if (!Array.isArray(conditions)) {
    return { isValid: false, message: 'Conditions should be an array.' };
  }

  for (let i = 0; i < conditions.length; i++) {
    const row = conditions[i];

    if (!Array.isArray(row) || row.length !== 3) {
      return {
        isValid: false,
        message: `Condition at index ${i} must be an array with 3 items: field, operator, and value.`,
      };
    }

    const [field, operator, value] = row;

    if (typeof field !== 'string' || field.trim() === '') {
      return {
        isValid: false,
        message: `Please provide a valid field in condition ${i + 1}.`,
      };
    }

    if (typeof operator !== 'string' || operator.trim() === '') {
      return {
        isValid: false,
        message: `Please provide a valid operator in condition ${i + 1}.`,
      };
    }

    if (!validOperators.includes(operator.trim())) {
      return {
        isValid: false,
        message: `Operator '${operator}' in condition ${i + 1} is not supported.`,
      };
    }

    if (value === undefined || value === null) {
      return {
        isValid: false,
        message: `Please provide a valid value in condition ${i + 1}.`,
      };
    }
  }

  return { isValid: true };
}

export function transformConditions(conditions, filterByDetails) {
  function normalizeValue(value) {
    if (typeof value === 'string' && !isNaN(value) && value.trim() !== '') {
      return Number(value);
    }
    return value;
  }
  return conditions.map(([field, operator, value]) => {
    if (!field) return [];
    if (filterByDetails) {
      const transformedField = field.startsWith('details.') ? field : `details.${field}`;
      return [transformedField, operator, normalizeValue(value)];
    }
    return [field, operator, normalizeValue(value)];
  });
}
